import ShowSuccess from "../Components/show-success";

const RegistrationLoginFormSubmitted = () => {
    return (
        <>
            <ShowSuccess
                message='Corporate Registration form submitted successfully!'
            />

        </>
    )
}

export default RegistrationLoginFormSubmitted;